import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {formInstantOfferStepKeys} from '@adv-mt/mt-form-instant-offer'
import {listItemsColors, listTitleSizes, listTypes} from '@adv-mt/mt-list-basic'

const BASE_CLASS_NAME = 'mt-LandingInstantOffer'
const BASE_LITERAL = 'INSTANT_OFFER.'
const vehicleStepBaseLiteral = `${BASE_LITERAL}HOW_WE_DO_IT.`
const userStepBaseLiteral = `${BASE_LITERAL}WHY_WE_NEED_USER_DATA.`

const listBasicProps = {
  isSingleColumn: true,
  itemsColor: listItemsColors.CURRENT_COLOR,
  titleSize: listTitleSizes.xs,
  type: listTypes.ICON
}

const commonLiteralsProps = {
  highlightStart: '<strong>',
  highlightEnd: '</strong>'
}
const vehicleStepsItemLiterals = ['WE_COMPARE', 'WE_OFFER_A_PRICE_RANGE', 'FINAL_OFFER']
const userStepsItemLiterals = ['WHY_WE_ASK_YOUR_NAME', 'WHY_WE_ASK_PHONE_AND_EMAIL']

const useInstantOfferAppraisalInfo = ({currentStep} = {}) => {
  const {i18n} = useContext(Context)

  const isVehicleStep = currentStep === formInstantOfferStepKeys.VEHICLE_DATA_STEP

  const baseLiterals = isVehicleStep ? vehicleStepBaseLiteral : userStepBaseLiteral

  const listTitle = i18n.t(`${baseLiterals}TITLE`)

  const itemLiterals = isVehicleStep ? vehicleStepsItemLiterals : userStepsItemLiterals

  const items = itemLiterals.map((itemText, index) => ({
    icon: () => <div className={`${BASE_CLASS_NAME}-infoSteps`}>{index + 1}</div>,
    value: i18n.t(`${baseLiterals}${itemText}`, commonLiteralsProps)
  }))

  return {
    listBasicProps: {...listBasicProps, items, title: listTitle}
  }
}

export {useInstantOfferAppraisalInfo}
